export enum UserTypeEnum {
    TENANT = 'tenant',
    WHITELABEL = 'wl',
    AFFILIATE_PARTNER = 'ap',
    NEW_APPLICATION = 'na',
    CLIENT = 'cli',
    SYS_ADMIN = 'sa',
    RESELLER = 'res',
}
